module.exports = __webpack_public_path__ + "img/logo3.f29dc137.png";